import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ApiModule } from './api/api.module';
import { AppRoutingModule } from './app-routing.module';

import {
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent,
} from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { msalConfig, protectedResources } from './auth-config';

import { GoogleTagManagerModule, ResolveLibModule } from 'resolve-lib';
import { AppComponent } from './app.component';
import { PageHeadingComponent } from './components/page-heading/page-heading.component';
import { WrapperComponent } from './components/wrapper/wrapper.component';
import { FooterNavMenuComponent } from './partials/footer-nav/footer-nav-menu.component';
import { HeaderNavComponent } from './partials/header-nav/header-nav.component';
import { LoadingScreenService } from './services/loading-screen/loading-screen.service';
import { LoadingScreenComponent } from './partials/loading-screen/loading-screen.component';
import { NoAccessComponent } from './components/no-access/no-access.component';

@NgModule({
  declarations: [AppComponent, FooterNavMenuComponent, WrapperComponent],
  bootstrap: [AppComponent, MsalRedirectComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ResolveLibModule,
    PageHeadingComponent,
    HeaderNavComponent,
    LoadingScreenComponent,
    NoAccessComponent,
    ApiModule.forRoot({
      rootUrl: environment.api.rootUrl,
    }),
    MsalModule.forRoot(
      new PublicClientApplication(msalConfig),
      {
        // The MSAL guard configuration.
        interactionType: InteractionType.Redirect,
      },
      {
        // The MSAL interceptor configuration.
        interactionType: InteractionType.Redirect,
        protectedResourceMap: protectedResources,
      }
    ),
    GoogleTagManagerModule.forRoot(environment.gtmAccountId),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    MsalGuard,
    LoadingScreenService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
